var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i5 = decorators.length - 1, decorator; i5 >= 0; i5--)
    if (decorator = decorators[i5])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};

// css-inline:components/ds-book-finder/ds-book-finder.css
var ds_book_finder_default = "/* Layering. The theme's existing stack, measured:\n     sidebar card ......... 100  (sections/sidebar.liquid:181)\n     nav ripple overlay ... 200  (ds-ripple-fill.css, default --ripple-z-index)\n     header sticky wrapper. 300\n     header controls ...... 999  (#menu-toggle-floating, cart link \u2014 position: fixed)\n     finder ripple fill ... 1000 (its own --ripple-z-index, set in the section)\n     this host ............ 1001\n\n   The finder is a full-screen takeover: its own ds-ripple-fill instance paints\n   the background over everything including the header, and this host sits one\n   step above that fill to hold the content. Both numbers move together \u2014 the\n   host must stay above the fill, and the fill above the header's 999 controls,\n   or the hamburger and cart show through the takeover.\n\n   Inside the host there is a second, local stack: .scroller (auto) < .bar (1)\n   < .dismiss (2). The bar has to beat the scroller so the rows pass *under* the\n   ruffled edge rather than over it, and the dismiss has to beat the bar so it is\n   never buried by it.\n\n   The host covers the viewport with pointer-events even where the content does\n   not, which is what stops those fixed header controls from being hit-tested\n   straight through the beige (the ripple canvas is pointer-events: none, so it\n   cannot do that job). */\n:host {\n  position: fixed;\n  inset: 0;\n  z-index: 1001;\n  display: block;\n  visibility: hidden;\n  pointer-events: none;\n  /* Clips .bar while it is parked below the viewport for its slide-up. Without\n     this, a fixed-position host with a child translated past its bottom edge can\n     still contribute scrollable overflow to the document. */\n  overflow: hidden;\n}\n\n/* Row sizing used to live here, as ds-card custom properties inherited down to\n   the slotted cards. There is no ds-card in the finder any more \u2014 the rows are\n   plain Liquid with a ds-card-media box \u2014 so those declarations read by nothing\n   and have been removed rather than left to look adjustable.\n\n   Where they went:\n     tile size ................ size / size-md on <ds-card-media> (96px / 144px)\n     gutter ................... the row's gap utilities\n     title to description ..... the text column's gap utility\n   All three are in snippets/book-finder-row.liquid. */\n\n/* No opacity transition on the host itself. The ripple fill is the entrance\n   animation now, and cross-fading the host on top of it dimmed the fill's own\n   first frames. Visibility flips immediately so the host starts swallowing\n   clicks the moment the fill begins to grow; .panel and .bar handle the reveal. */\n:host([open]) {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n/* `closing` spans the window between close() and the fill actually clearing.\n   The host stays visible and interactive \u2014 visibility: hidden would stop it\n   receiving pointer events, which is the whole point \u2014 while everything inside\n   is hidden, so it looks exactly as it did before (all gone at once) but still\n   swallows a second click instead of passing it to the page underneath. */\n:host([closing]) {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n:host([closing]) .panel,\n:host([closing]) .bar,\n:host([closing]) .dismiss {\n  visibility: hidden;\n}\n\n/* The scroll container, and the reason it is full-bleed rather than being the\n   content column itself: a scrollbar belongs at the edge of the screen. When\n   .panel scrolled, its scrollbar rendered against the right edge of a 34rem\n   column \u2014 a bar floating in open space in the middle of the takeover.\n\n   It doubles as the click-to-close surface, replacing a separate .backdrop\n   element (see _onScrollerClick for the target check that costs).\n\n   Centring is `margin: auto` on the child rather than `align-items: center`\n   here. They look identical until the content is taller than the viewport, at\n   which point centring clips the top of the content *and* makes it\n   unscrollable; auto margins collapse to zero on the overflowing axis instead,\n   so a long book list stays reachable from both ends. That case is mobile's\n   normal state, not an edge case. */\n.scroller {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n/* Pinned to the viewport rather than to the content column, so it stays put\n   regardless of how tall the book list is or how far it has been scrolled. */\n.dismiss {\n  position: absolute;\n  top: var(--spacing-400);\n  right: var(--spacing-400);\n  z-index: 2;\n\n  @media (min-width: 800px) {\n    top: var(--spacing-500);\n    right: var(--spacing-500);\n  }\n}\n\n/* The slim footer bar, pinned across the foot of the takeover. Inside the host,\n   so it clears the ripple fill without a z-index of its own \u2014 the host already\n   sits above it.\n\n   It overlays the content rather than taking a row in the flex flow, which is\n   what the design shows: rows pass under the ruffled edge, so the list reads as\n   continuing rather than stopping short. .panel pays for that with matching\n   bottom padding (below) so the *end* of the list can still scroll clear of it. */\n.bar {\n  position: absolute;\n  inset: auto 0 0 0;\n  z-index: 1;\n\n  /* Slides up into place with the content. The parked position clears its own\n     height *plus* 2rem, because assets/base.css hangs the ruffled edge off a\n     ::before at top: -30px \u2014 a plain translateY(100%) leaves that edge peeking\n     above the bottom of the screen as a stray dark sliver. */\n  transform: translateY(calc(100% + 2rem));\n  transition: transform 380ms cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.panel {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin: 80px auto 0;\n  width: 100%;\n  /* A centred column, not a card: the ripple fill behind it is the surface, so\n     there is no background, border-radius or shadow here.\n\n     41rem (656px), widened from 34rem when the row tiles grew. The arithmetic,\n     at the widest step, taking the numbers from where they actually live now \u2014\n     ds-card-media's `m` size and the row's own gap utility, both in\n     snippets/book-finder-row.liquid: 656 less the content wrapper's 32px\n     horizontal padding each side leaves 592, and a 144px tile plus its 32px\n     gutter takes 176 of that, so the title and description get 416px. At the old\n     544px they would have had 304px, which wrapped a title like \"Sci-Fi\n     Adventure - Short Story Collection\" onto three lines.\n\n     Recomputed in review on #108: this previously cited a 224px tile and a 40px\n     gutter, which were the values before ds-card-media took over the box.\n\n     Only ever a cap, never a floor: .panel is width: 100%, so on anything\n     narrower than this the column simply fills the viewport and the number\n     never comes into play. That is why there is no mobile step. */\n  max-width: var(--finder-width, 41rem);\n\n  /* Revealed a beat after the fill starts, so the content arrives on a surface\n     that is already there rather than racing it. The delay itself is JS\n     (`content-delay`), because it has to survive the fill's easing curve being\n     retuned; this is only the fade. */\n  opacity: 0;\n  transform: translateY(8px);\n  transition:\n    opacity 240ms ease,\n    transform 240ms ease;\n\n  /* Clearance for the overlaying .bar, so the last row is reachable instead of\n     stranded underneath it. From 1024px only, matching where the bar itself\n     renders \u2014 it is desktop-only in both variants, so below that there is\n     nothing overlaying anything and this would be dead space.\n\n     A token with a measured default rather than something derived: the bar is\n     ~60px (20px padding either side of one caption-em line), and CSS cannot read\n     a sibling's height. Overridable if the bar's content ever grows. */\n  @media (min-width: 1024px) {\n    padding-bottom: var(--finder-footer-clearance, 5rem);\n  }\n}\n\n:host([content-in]) .panel {\n  opacity: 1;\n  transform: none;\n}\n\n:host([content-in]) .bar {\n  transform: none;\n}\n\n/* Both reveals collapse to \"already there\". The bar keeps no transform at all,\n   rather than transitioning instantly, so it never renders parked off-screen. */\n@media (prefers-reduced-motion: reduce) {\n  .panel,\n  .bar {\n    transition: none;\n    transform: none;\n  }\n}\n";

// node_modules/@lit/reactive-element/css-tag.js
var t = globalThis;
var e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var s = /* @__PURE__ */ Symbol();
var o = /* @__PURE__ */ new WeakMap();
var n = class {
  constructor(t4, e5, o6) {
    if (this._$cssResult$ = true, o6 !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t4, this.t = e5;
  }
  get styleSheet() {
    let t4 = this.o;
    const s4 = this.t;
    if (e && void 0 === t4) {
      const e5 = void 0 !== s4 && 1 === s4.length;
      e5 && (t4 = o.get(s4)), void 0 === t4 && ((this.o = t4 = new CSSStyleSheet()).replaceSync(this.cssText), e5 && o.set(s4, t4));
    }
    return t4;
  }
  toString() {
    return this.cssText;
  }
};
var r = (t4) => new n("string" == typeof t4 ? t4 : t4 + "", void 0, s);
var i = (t4, ...e5) => {
  const o6 = 1 === t4.length ? t4[0] : e5.reduce((e6, s4, o7) => e6 + ((t5) => {
    if (true === t5._$cssResult$) return t5.cssText;
    if ("number" == typeof t5) return t5;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + t5 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s4) + t4[o7 + 1], t4[0]);
  return new n(o6, t4, s);
};
var S = (s4, o6) => {
  if (e) s4.adoptedStyleSheets = o6.map((t4) => t4 instanceof CSSStyleSheet ? t4 : t4.styleSheet);
  else for (const e5 of o6) {
    const o7 = document.createElement("style"), n5 = t.litNonce;
    void 0 !== n5 && o7.setAttribute("nonce", n5), o7.textContent = e5.cssText, s4.appendChild(o7);
  }
};
var c = e ? (t4) => t4 : (t4) => t4 instanceof CSSStyleSheet ? ((t5) => {
  let e5 = "";
  for (const s4 of t5.cssRules) e5 += s4.cssText;
  return r(e5);
})(t4) : t4;

// node_modules/@lit/reactive-element/reactive-element.js
var { is: i2, defineProperty: e2, getOwnPropertyDescriptor: h, getOwnPropertyNames: r2, getOwnPropertySymbols: o2, getPrototypeOf: n2 } = Object;
var a = globalThis;
var c2 = a.trustedTypes;
var l = c2 ? c2.emptyScript : "";
var p = a.reactiveElementPolyfillSupport;
var d = (t4, s4) => t4;
var u = { toAttribute(t4, s4) {
  switch (s4) {
    case Boolean:
      t4 = t4 ? l : null;
      break;
    case Object:
    case Array:
      t4 = null == t4 ? t4 : JSON.stringify(t4);
  }
  return t4;
}, fromAttribute(t4, s4) {
  let i5 = t4;
  switch (s4) {
    case Boolean:
      i5 = null !== t4;
      break;
    case Number:
      i5 = null === t4 ? null : Number(t4);
      break;
    case Object:
    case Array:
      try {
        i5 = JSON.parse(t4);
      } catch (t5) {
        i5 = null;
      }
  }
  return i5;
} };
var f = (t4, s4) => !i2(t4, s4);
var b = { attribute: true, type: String, converter: u, reflect: false, useDefault: false, hasChanged: f };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), a.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
var y = class extends HTMLElement {
  static addInitializer(t4) {
    this._$Ei(), (this.l ??= []).push(t4);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t4, s4 = b) {
    if (s4.state && (s4.attribute = false), this._$Ei(), this.prototype.hasOwnProperty(t4) && ((s4 = Object.create(s4)).wrapped = true), this.elementProperties.set(t4, s4), !s4.noAccessor) {
      const i5 = /* @__PURE__ */ Symbol(), h3 = this.getPropertyDescriptor(t4, i5, s4);
      void 0 !== h3 && e2(this.prototype, t4, h3);
    }
  }
  static getPropertyDescriptor(t4, s4, i5) {
    const { get: e5, set: r6 } = h(this.prototype, t4) ?? { get() {
      return this[s4];
    }, set(t5) {
      this[s4] = t5;
    } };
    return { get: e5, set(s5) {
      const h3 = e5?.call(this);
      r6?.call(this, s5), this.requestUpdate(t4, h3, i5);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t4) {
    return this.elementProperties.get(t4) ?? b;
  }
  static _$Ei() {
    if (this.hasOwnProperty(d("elementProperties"))) return;
    const t4 = n2(this);
    t4.finalize(), void 0 !== t4.l && (this.l = [...t4.l]), this.elementProperties = new Map(t4.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(d("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(d("properties"))) {
      const t5 = this.properties, s4 = [...r2(t5), ...o2(t5)];
      for (const i5 of s4) this.createProperty(i5, t5[i5]);
    }
    const t4 = this[Symbol.metadata];
    if (null !== t4) {
      const s4 = litPropertyMetadata.get(t4);
      if (void 0 !== s4) for (const [t5, i5] of s4) this.elementProperties.set(t5, i5);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t5, s4] of this.elementProperties) {
      const i5 = this._$Eu(t5, s4);
      void 0 !== i5 && this._$Eh.set(i5, t5);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(s4) {
    const i5 = [];
    if (Array.isArray(s4)) {
      const e5 = new Set(s4.flat(1 / 0).reverse());
      for (const s5 of e5) i5.unshift(c(s5));
    } else void 0 !== s4 && i5.push(c(s4));
    return i5;
  }
  static _$Eu(t4, s4) {
    const i5 = s4.attribute;
    return false === i5 ? void 0 : "string" == typeof i5 ? i5 : "string" == typeof t4 ? t4.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t4) => this.enableUpdating = t4), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t4) => t4(this));
  }
  addController(t4) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t4), void 0 !== this.renderRoot && this.isConnected && t4.hostConnected?.();
  }
  removeController(t4) {
    this._$EO?.delete(t4);
  }
  _$E_() {
    const t4 = /* @__PURE__ */ new Map(), s4 = this.constructor.elementProperties;
    for (const i5 of s4.keys()) this.hasOwnProperty(i5) && (t4.set(i5, this[i5]), delete this[i5]);
    t4.size > 0 && (this._$Ep = t4);
  }
  createRenderRoot() {
    const t4 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S(t4, this.constructor.elementStyles), t4;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(true), this._$EO?.forEach((t4) => t4.hostConnected?.());
  }
  enableUpdating(t4) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t4) => t4.hostDisconnected?.());
  }
  attributeChangedCallback(t4, s4, i5) {
    this._$AK(t4, i5);
  }
  _$ET(t4, s4) {
    const i5 = this.constructor.elementProperties.get(t4), e5 = this.constructor._$Eu(t4, i5);
    if (void 0 !== e5 && true === i5.reflect) {
      const h3 = (void 0 !== i5.converter?.toAttribute ? i5.converter : u).toAttribute(s4, i5.type);
      this._$Em = t4, null == h3 ? this.removeAttribute(e5) : this.setAttribute(e5, h3), this._$Em = null;
    }
  }
  _$AK(t4, s4) {
    const i5 = this.constructor, e5 = i5._$Eh.get(t4);
    if (void 0 !== e5 && this._$Em !== e5) {
      const t5 = i5.getPropertyOptions(e5), h3 = "function" == typeof t5.converter ? { fromAttribute: t5.converter } : void 0 !== t5.converter?.fromAttribute ? t5.converter : u;
      this._$Em = e5;
      const r6 = h3.fromAttribute(s4, t5.type);
      this[e5] = r6 ?? this._$Ej?.get(e5) ?? r6, this._$Em = null;
    }
  }
  requestUpdate(t4, s4, i5, e5 = false, h3) {
    if (void 0 !== t4) {
      const r6 = this.constructor;
      if (false === e5 && (h3 = this[t4]), i5 ??= r6.getPropertyOptions(t4), !((i5.hasChanged ?? f)(h3, s4) || i5.useDefault && i5.reflect && h3 === this._$Ej?.get(t4) && !this.hasAttribute(r6._$Eu(t4, i5)))) return;
      this.C(t4, s4, i5);
    }
    false === this.isUpdatePending && (this._$ES = this._$EP());
  }
  C(t4, s4, { useDefault: i5, reflect: e5, wrapped: h3 }, r6) {
    i5 && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t4) && (this._$Ej.set(t4, r6 ?? s4 ?? this[t4]), true !== h3 || void 0 !== r6) || (this._$AL.has(t4) || (this.hasUpdated || i5 || (s4 = void 0), this._$AL.set(t4, s4)), true === e5 && this._$Em !== t4 && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t4));
  }
  async _$EP() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (t5) {
      Promise.reject(t5);
    }
    const t4 = this.scheduleUpdate();
    return null != t4 && await t4, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [t6, s5] of this._$Ep) this[t6] = s5;
        this._$Ep = void 0;
      }
      const t5 = this.constructor.elementProperties;
      if (t5.size > 0) for (const [s5, i5] of t5) {
        const { wrapped: t6 } = i5, e5 = this[s5];
        true !== t6 || this._$AL.has(s5) || void 0 === e5 || this.C(s5, void 0, i5, e5);
      }
    }
    let t4 = false;
    const s4 = this._$AL;
    try {
      t4 = this.shouldUpdate(s4), t4 ? (this.willUpdate(s4), this._$EO?.forEach((t5) => t5.hostUpdate?.()), this.update(s4)) : this._$EM();
    } catch (s5) {
      throw t4 = false, this._$EM(), s5;
    }
    t4 && this._$AE(s4);
  }
  willUpdate(t4) {
  }
  _$AE(t4) {
    this._$EO?.forEach((t5) => t5.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t4)), this.updated(t4);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t4) {
    return true;
  }
  update(t4) {
    this._$Eq &&= this._$Eq.forEach((t5) => this._$ET(t5, this[t5])), this._$EM();
  }
  updated(t4) {
  }
  firstUpdated(t4) {
  }
};
y.elementStyles = [], y.shadowRootOptions = { mode: "open" }, y[d("elementProperties")] = /* @__PURE__ */ new Map(), y[d("finalized")] = /* @__PURE__ */ new Map(), p?.({ ReactiveElement: y }), (a.reactiveElementVersions ??= []).push("2.1.2");

// node_modules/lit-html/lit-html.js
var t2 = globalThis;
var i3 = (t4) => t4;
var s2 = t2.trustedTypes;
var e3 = s2 ? s2.createPolicy("lit-html", { createHTML: (t4) => t4 }) : void 0;
var h2 = "$lit$";
var o3 = `lit$${Math.random().toFixed(9).slice(2)}$`;
var n3 = "?" + o3;
var r3 = `<${n3}>`;
var l2 = document;
var c3 = () => l2.createComment("");
var a2 = (t4) => null === t4 || "object" != typeof t4 && "function" != typeof t4;
var u2 = Array.isArray;
var d2 = (t4) => u2(t4) || "function" == typeof t4?.[Symbol.iterator];
var f2 = "[ 	\n\f\r]";
var v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g;
var _ = /-->/g;
var m = />/g;
var p2 = RegExp(`>|${f2}(?:([^\\s"'>=/]+)(${f2}*=${f2}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g");
var g = /'/g;
var $ = /"/g;
var y2 = /^(?:script|style|textarea|title)$/i;
var x = (t4) => (i5, ...s4) => ({ _$litType$: t4, strings: i5, values: s4 });
var b2 = x(1);
var w = x(2);
var T = x(3);
var E = /* @__PURE__ */ Symbol.for("lit-noChange");
var A = /* @__PURE__ */ Symbol.for("lit-nothing");
var C = /* @__PURE__ */ new WeakMap();
var P = l2.createTreeWalker(l2, 129);
function V(t4, i5) {
  if (!u2(t4) || !t4.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== e3 ? e3.createHTML(i5) : i5;
}
var N = (t4, i5) => {
  const s4 = t4.length - 1, e5 = [];
  let n5, l3 = 2 === i5 ? "<svg>" : 3 === i5 ? "<math>" : "", c4 = v;
  for (let i6 = 0; i6 < s4; i6++) {
    const s5 = t4[i6];
    let a3, u3, d3 = -1, f3 = 0;
    for (; f3 < s5.length && (c4.lastIndex = f3, u3 = c4.exec(s5), null !== u3); ) f3 = c4.lastIndex, c4 === v ? "!--" === u3[1] ? c4 = _ : void 0 !== u3[1] ? c4 = m : void 0 !== u3[2] ? (y2.test(u3[2]) && (n5 = RegExp("</" + u3[2], "g")), c4 = p2) : void 0 !== u3[3] && (c4 = p2) : c4 === p2 ? ">" === u3[0] ? (c4 = n5 ?? v, d3 = -1) : void 0 === u3[1] ? d3 = -2 : (d3 = c4.lastIndex - u3[2].length, a3 = u3[1], c4 = void 0 === u3[3] ? p2 : '"' === u3[3] ? $ : g) : c4 === $ || c4 === g ? c4 = p2 : c4 === _ || c4 === m ? c4 = v : (c4 = p2, n5 = void 0);
    const x2 = c4 === p2 && t4[i6 + 1].startsWith("/>") ? " " : "";
    l3 += c4 === v ? s5 + r3 : d3 >= 0 ? (e5.push(a3), s5.slice(0, d3) + h2 + s5.slice(d3) + o3 + x2) : s5 + o3 + (-2 === d3 ? i6 : x2);
  }
  return [V(t4, l3 + (t4[s4] || "<?>") + (2 === i5 ? "</svg>" : 3 === i5 ? "</math>" : "")), e5];
};
var S2 = class _S {
  constructor({ strings: t4, _$litType$: i5 }, e5) {
    let r6;
    this.parts = [];
    let l3 = 0, a3 = 0;
    const u3 = t4.length - 1, d3 = this.parts, [f3, v2] = N(t4, i5);
    if (this.el = _S.createElement(f3, e5), P.currentNode = this.el.content, 2 === i5 || 3 === i5) {
      const t5 = this.el.content.firstChild;
      t5.replaceWith(...t5.childNodes);
    }
    for (; null !== (r6 = P.nextNode()) && d3.length < u3; ) {
      if (1 === r6.nodeType) {
        if (r6.hasAttributes()) for (const t5 of r6.getAttributeNames()) if (t5.endsWith(h2)) {
          const i6 = v2[a3++], s4 = r6.getAttribute(t5).split(o3), e6 = /([.?@])?(.*)/.exec(i6);
          d3.push({ type: 1, index: l3, name: e6[2], strings: s4, ctor: "." === e6[1] ? I : "?" === e6[1] ? L : "@" === e6[1] ? z : H }), r6.removeAttribute(t5);
        } else t5.startsWith(o3) && (d3.push({ type: 6, index: l3 }), r6.removeAttribute(t5));
        if (y2.test(r6.tagName)) {
          const t5 = r6.textContent.split(o3), i6 = t5.length - 1;
          if (i6 > 0) {
            r6.textContent = s2 ? s2.emptyScript : "";
            for (let s4 = 0; s4 < i6; s4++) r6.append(t5[s4], c3()), P.nextNode(), d3.push({ type: 2, index: ++l3 });
            r6.append(t5[i6], c3());
          }
        }
      } else if (8 === r6.nodeType) if (r6.data === n3) d3.push({ type: 2, index: l3 });
      else {
        let t5 = -1;
        for (; -1 !== (t5 = r6.data.indexOf(o3, t5 + 1)); ) d3.push({ type: 7, index: l3 }), t5 += o3.length - 1;
      }
      l3++;
    }
  }
  static createElement(t4, i5) {
    const s4 = l2.createElement("template");
    return s4.innerHTML = t4, s4;
  }
};
function M(t4, i5, s4 = t4, e5) {
  if (i5 === E) return i5;
  let h3 = void 0 !== e5 ? s4._$Co?.[e5] : s4._$Cl;
  const o6 = a2(i5) ? void 0 : i5._$litDirective$;
  return h3?.constructor !== o6 && (h3?._$AO?.(false), void 0 === o6 ? h3 = void 0 : (h3 = new o6(t4), h3._$AT(t4, s4, e5)), void 0 !== e5 ? (s4._$Co ??= [])[e5] = h3 : s4._$Cl = h3), void 0 !== h3 && (i5 = M(t4, h3._$AS(t4, i5.values), h3, e5)), i5;
}
var R = class {
  constructor(t4, i5) {
    this._$AV = [], this._$AN = void 0, this._$AD = t4, this._$AM = i5;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t4) {
    const { el: { content: i5 }, parts: s4 } = this._$AD, e5 = (t4?.creationScope ?? l2).importNode(i5, true);
    P.currentNode = e5;
    let h3 = P.nextNode(), o6 = 0, n5 = 0, r6 = s4[0];
    for (; void 0 !== r6; ) {
      if (o6 === r6.index) {
        let i6;
        2 === r6.type ? i6 = new k(h3, h3.nextSibling, this, t4) : 1 === r6.type ? i6 = new r6.ctor(h3, r6.name, r6.strings, this, t4) : 6 === r6.type && (i6 = new Z(h3, this, t4)), this._$AV.push(i6), r6 = s4[++n5];
      }
      o6 !== r6?.index && (h3 = P.nextNode(), o6++);
    }
    return P.currentNode = l2, e5;
  }
  p(t4) {
    let i5 = 0;
    for (const s4 of this._$AV) void 0 !== s4 && (void 0 !== s4.strings ? (s4._$AI(t4, s4, i5), i5 += s4.strings.length - 2) : s4._$AI(t4[i5])), i5++;
  }
};
var k = class _k {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t4, i5, s4, e5) {
    this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = t4, this._$AB = i5, this._$AM = s4, this.options = e5, this._$Cv = e5?.isConnected ?? true;
  }
  get parentNode() {
    let t4 = this._$AA.parentNode;
    const i5 = this._$AM;
    return void 0 !== i5 && 11 === t4?.nodeType && (t4 = i5.parentNode), t4;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t4, i5 = this) {
    t4 = M(this, t4, i5), a2(t4) ? t4 === A || null == t4 || "" === t4 ? (this._$AH !== A && this._$AR(), this._$AH = A) : t4 !== this._$AH && t4 !== E && this._(t4) : void 0 !== t4._$litType$ ? this.$(t4) : void 0 !== t4.nodeType ? this.T(t4) : d2(t4) ? this.k(t4) : this._(t4);
  }
  O(t4) {
    return this._$AA.parentNode.insertBefore(t4, this._$AB);
  }
  T(t4) {
    this._$AH !== t4 && (this._$AR(), this._$AH = this.O(t4));
  }
  _(t4) {
    this._$AH !== A && a2(this._$AH) ? this._$AA.nextSibling.data = t4 : this.T(l2.createTextNode(t4)), this._$AH = t4;
  }
  $(t4) {
    const { values: i5, _$litType$: s4 } = t4, e5 = "number" == typeof s4 ? this._$AC(t4) : (void 0 === s4.el && (s4.el = S2.createElement(V(s4.h, s4.h[0]), this.options)), s4);
    if (this._$AH?._$AD === e5) this._$AH.p(i5);
    else {
      const t5 = new R(e5, this), s5 = t5.u(this.options);
      t5.p(i5), this.T(s5), this._$AH = t5;
    }
  }
  _$AC(t4) {
    let i5 = C.get(t4.strings);
    return void 0 === i5 && C.set(t4.strings, i5 = new S2(t4)), i5;
  }
  k(t4) {
    u2(this._$AH) || (this._$AH = [], this._$AR());
    const i5 = this._$AH;
    let s4, e5 = 0;
    for (const h3 of t4) e5 === i5.length ? i5.push(s4 = new _k(this.O(c3()), this.O(c3()), this, this.options)) : s4 = i5[e5], s4._$AI(h3), e5++;
    e5 < i5.length && (this._$AR(s4 && s4._$AB.nextSibling, e5), i5.length = e5);
  }
  _$AR(t4 = this._$AA.nextSibling, s4) {
    for (this._$AP?.(false, true, s4); t4 !== this._$AB; ) {
      const s5 = i3(t4).nextSibling;
      i3(t4).remove(), t4 = s5;
    }
  }
  setConnected(t4) {
    void 0 === this._$AM && (this._$Cv = t4, this._$AP?.(t4));
  }
};
var H = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t4, i5, s4, e5, h3) {
    this.type = 1, this._$AH = A, this._$AN = void 0, this.element = t4, this.name = i5, this._$AM = e5, this.options = h3, s4.length > 2 || "" !== s4[0] || "" !== s4[1] ? (this._$AH = Array(s4.length - 1).fill(new String()), this.strings = s4) : this._$AH = A;
  }
  _$AI(t4, i5 = this, s4, e5) {
    const h3 = this.strings;
    let o6 = false;
    if (void 0 === h3) t4 = M(this, t4, i5, 0), o6 = !a2(t4) || t4 !== this._$AH && t4 !== E, o6 && (this._$AH = t4);
    else {
      const e6 = t4;
      let n5, r6;
      for (t4 = h3[0], n5 = 0; n5 < h3.length - 1; n5++) r6 = M(this, e6[s4 + n5], i5, n5), r6 === E && (r6 = this._$AH[n5]), o6 ||= !a2(r6) || r6 !== this._$AH[n5], r6 === A ? t4 = A : t4 !== A && (t4 += (r6 ?? "") + h3[n5 + 1]), this._$AH[n5] = r6;
    }
    o6 && !e5 && this.j(t4);
  }
  j(t4) {
    t4 === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t4 ?? "");
  }
};
var I = class extends H {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t4) {
    this.element[this.name] = t4 === A ? void 0 : t4;
  }
};
var L = class extends H {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t4) {
    this.element.toggleAttribute(this.name, !!t4 && t4 !== A);
  }
};
var z = class extends H {
  constructor(t4, i5, s4, e5, h3) {
    super(t4, i5, s4, e5, h3), this.type = 5;
  }
  _$AI(t4, i5 = this) {
    if ((t4 = M(this, t4, i5, 0) ?? A) === E) return;
    const s4 = this._$AH, e5 = t4 === A && s4 !== A || t4.capture !== s4.capture || t4.once !== s4.once || t4.passive !== s4.passive, h3 = t4 !== A && (s4 === A || e5);
    e5 && this.element.removeEventListener(this.name, this, s4), h3 && this.element.addEventListener(this.name, this, t4), this._$AH = t4;
  }
  handleEvent(t4) {
    "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t4) : this._$AH.handleEvent(t4);
  }
};
var Z = class {
  constructor(t4, i5, s4) {
    this.element = t4, this.type = 6, this._$AN = void 0, this._$AM = i5, this.options = s4;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t4) {
    M(this, t4);
  }
};
var B = t2.litHtmlPolyfillSupport;
B?.(S2, k), (t2.litHtmlVersions ??= []).push("3.3.3");
var D = (t4, i5, s4) => {
  const e5 = s4?.renderBefore ?? i5;
  let h3 = e5._$litPart$;
  if (void 0 === h3) {
    const t5 = s4?.renderBefore ?? null;
    e5._$litPart$ = h3 = new k(i5.insertBefore(c3(), t5), t5, void 0, s4 ?? {});
  }
  return h3._$AI(t4), h3;
};

// node_modules/lit-element/lit-element.js
var s3 = globalThis;
var i4 = class extends y {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t4 = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t4.firstChild, t4;
  }
  update(t4) {
    const r6 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t4), this._$Do = D(r6, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(true);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(false);
  }
  render() {
    return E;
  }
};
i4._$litElement$ = true, i4["finalized"] = true, s3.litElementHydrateSupport?.({ LitElement: i4 });
var o4 = s3.litElementPolyfillSupport;
o4?.({ LitElement: i4 });
(s3.litElementVersions ??= []).push("4.2.2");

// node_modules/@lit/reactive-element/decorators/custom-element.js
var t3 = (t4) => (e5, o6) => {
  void 0 !== o6 ? o6.addInitializer(() => {
    customElements.define(t4, e5);
  }) : customElements.define(t4, e5);
};

// node_modules/@lit/reactive-element/decorators/property.js
var o5 = { attribute: true, type: String, converter: u, reflect: false, hasChanged: f };
var r4 = (t4 = o5, e5, r6) => {
  const { kind: n5, metadata: i5 } = r6;
  let s4 = globalThis.litPropertyMetadata.get(i5);
  if (void 0 === s4 && globalThis.litPropertyMetadata.set(i5, s4 = /* @__PURE__ */ new Map()), "setter" === n5 && ((t4 = Object.create(t4)).wrapped = true), s4.set(r6.name, t4), "accessor" === n5) {
    const { name: o6 } = r6;
    return { set(r7) {
      const n6 = e5.get.call(this);
      e5.set.call(this, r7), this.requestUpdate(o6, n6, t4, true, r7);
    }, init(e6) {
      return void 0 !== e6 && this.C(o6, void 0, t4, e6), e6;
    } };
  }
  if ("setter" === n5) {
    const { name: o6 } = r6;
    return function(r7) {
      const n6 = this[o6];
      e5.call(this, r7), this.requestUpdate(o6, n6, t4, true, r7);
    };
  }
  throw Error("Unsupported decorator location: " + n5);
};
function n4(t4) {
  return (e5, o6) => "object" == typeof o6 ? r4(t4, e5, o6) : ((t5, e6, o7) => {
    const r6 = e6.hasOwnProperty(o7);
    return e6.constructor.createProperty(o7, t5), r6 ? Object.getOwnPropertyDescriptor(e6, o7) : void 0;
  })(t4, e5, o6);
}

// node_modules/@lit/reactive-element/decorators/state.js
function r5(r6) {
  return n4({ ...r6, state: true, attribute: false });
}

// components/styles/shared.ts
var shared = i`
  button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .button-wrapper {
    all: unset;
    box-sizing: border-box;
    display: flex;
    cursor: pointer;
  }

  * {
    box-sizing: border-box;
    min-width: 0;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
`;

// components/base-component.ts
var BaseComponent = class extends i4 {
  static {
    this.styles = [shared];
  }
};

// components/ds-book-finder/ds-book-finder.ts
var DsBookFinder = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.triggerSelector = "";
    this.rippleSelector = "";
    this.contentDelay = 400;
    this.label = "Choose your book";
    this._open = false;
    this._contentTimer = 0;
    this._closingTimer = 0;
    /**
     * Trigger clicks are delegated from `document` for the same reason: it survives
     * the trigger being replaced, with no rebinding on `shopify:section:load`.
     */
    this._onDocumentClick = (event) => {
      if (this._isChooseLink(event)) {
        event.preventDefault();
        this.open("link");
        return;
      }
      if (!this.triggerSelector) return;
      const target = event.target;
      if (!target?.closest(this.triggerSelector)) return;
      event.preventDefault();
      this.toggle("trigger");
    };
    this._onKeydown = (event) => {
      if (event.key === "Escape") this.close("escape");
    };
    /**
     * Clicking the empty area around the content closes, alongside Escape and the
     * close button.
     *
     * This replaced a dedicated full-bleed `.backdrop` sibling of `.panel`, which
     * needed no target check because a click on panel content could never reach
     * it. `.scroller` is the panel's *ancestor* — it has to be, to put the
     * scrollbar at the screen edge — so panel clicks do bubble through and have to
     * be excluded. `event.target === currentTarget` is what does that: clicking
     * beside the centred column targets the scroller itself, clicking the column
     * targets something inside it.
     *
     * Listening here rather than on the host is deliberate. A listener on the host
     * sees events from its own shadow tree retargeted to the host, so the same
     * comparison would match every click and close on all of them.
     *
     * The close reason stays "backdrop" so the existing book_finder_closed
     * breakdown keeps its history across this refactor.
     */
    this._onScrollerClick = (event) => {
      if (event.target === event.currentTarget) this.close("backdrop");
    };
    /**
     * Close requests from slotted light-DOM content — the section's back arrow.
     * Delegated from the host rather than wired to a specific element, because the
     * button is authored in Liquid and this component never sees it directly.
     */
    this._onClick = (event) => {
      const target = event.target;
      if (target?.closest("[data-finder-close]")) this.close("back_button");
    };
  }
  firstUpdated() {
    this._trigger()?.setAttribute("aria-expanded", "false");
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener("click", this._onDocumentClick);
    document.removeEventListener("keydown", this._onKeydown);
    this._clearContentTimer();
    this._clearClosing();
    this._releaseScrollLock();
  }
  render() {
    return b2`
      <div class="scroller" @click=${this._onScrollerClick}>
        <div class="panel" role="dialog" aria-label="${this.label}">
          <slot></slot>
        </div>
      </div>
      <div class="bar"><slot name="footer"></slot></div>
      <div class="dismiss"><slot name="dismiss"></slot></div>
    `;
  }
  // -- Public API, mirroring ds-ripple-fill --
  /**
   * `source` / `reason` describe what drove the change and ride on the event
   * detail. They exist for analytics (ENG-744: `book_finder_opened` /
   * `book_finder_closed`), but this component knows nothing about PostHog —
   * `snippets/posthog.liquid` listens for these events and captures them. It
   * also cannot know that its trigger is the sidebar CTA, only that
   * `triggerSelector` matched, hence the generic `"trigger"`.
   *
   * Both default to `"api"`, so a programmatic `open()` from elsewhere stays
   * distinguishable from a real interaction rather than being miscounted as
   * one. The arguments are optional, so the existing call signature is
   * unchanged.
   */
  open(source = "api") {
    if (this._open) return;
    this._open = true;
    this.toggleAttribute("open", true);
    document.body.classList.add("scroll-locked");
    document.addEventListener("keydown", this._onKeydown);
    this._trigger()?.setAttribute("aria-expanded", "true");
    this._clearClosing();
    this._ripple()?.open();
    this._clearContentTimer();
    if (this.contentDelay > 0 && !this._prefersReducedMotion()) {
      this._contentTimer = window.setTimeout(
        () => this._setContentIn(true),
        this.contentDelay
      );
    } else {
      this._setContentIn(true);
    }
    this.dispatchEvent(
      new CustomEvent("book-finder-open", {
        bubbles: true,
        composed: true,
        detail: { source }
      })
    );
  }
  close(reason = "api") {
    if (!this._open) return;
    this._open = false;
    this.toggleAttribute("open", false);
    this._clearContentTimer();
    this._setContentIn(false);
    this._releaseScrollLock();
    this.toggleAttribute("closing", true);
    const ripple = this._ripple();
    if (!ripple) {
      this.toggleAttribute("closing", false);
    } else {
      const done = () => this._clearClosing();
      ripple.addEventListener("ripple-closed", done, { once: true });
      this._closingTimer = window.setTimeout(done, 1500);
      ripple.close();
    }
    document.removeEventListener("keydown", this._onKeydown);
    this._trigger()?.setAttribute("aria-expanded", "false");
    this.dispatchEvent(
      new CustomEvent("book-finder-close", {
        bubbles: true,
        composed: true,
        detail: { reason }
      })
    );
  }
  toggle(source = "api") {
    if (this._open) this.close(source);
    else this.open(source);
  }
  // -- Internals --
  /**
   * Resolved on demand rather than cached. The trigger lives in another section
   * (`sections/sidebar.liquid`), and the Shopify theme editor re-renders sections
   * independently — editing the sidebar replaces the button while this component
   * stays mounted, so a reference captured once would point at a detached node
   * and the CTA would silently stop working until a full reload.
   */
  _trigger() {
    return this.triggerSelector ? document.querySelector(this.triggerSelector) : null;
  }
  /** Resolved on demand, for the same theme-editor reason as `_trigger`. */
  _ripple() {
    if (!this.rippleSelector) return null;
    const el = document.querySelector(this.rippleSelector);
    return typeof el?.open === "function" ? el : null;
  }
  /**
   * Reveal or hide the content, as the `content-in` attribute for CSS to fade on.
   * Deliberately an attribute and no backing field: nothing in render() depends
   * on it, so a @state() property would only buy a re-render that produces the
   * identical template. It is separate from `open` because the host has to be
   * present and catching clicks from the fill's very first frame, while the
   * content deliberately is not.
   */
  _setContentIn(value) {
    this.toggleAttribute("content-in", value);
  }
  _clearClosing() {
    if (this._closingTimer) {
      clearTimeout(this._closingTimer);
      this._closingTimer = 0;
    }
    this.toggleAttribute("closing", false);
  }
  _clearContentTimer() {
    if (this._contentTimer) {
      clearTimeout(this._contentTimer);
      this._contentTimer = 0;
    }
  }
  _prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  /* With the finder on this page, a choose-your-book link opens it in place;
     modified clicks still navigate so the link can open in a new tab. */
  _isChooseLink(event) {
    const mouse = event;
    if (mouse.metaKey || mouse.ctrlKey || mouse.shiftKey || mouse.altKey || mouse.button > 0) return false;
    const link = event.target?.closest?.("a[href]");
    if (!(link instanceof HTMLAnchorElement)) return false;
    try {
      return new URL(link.href, window.location.href).searchParams.has("choose-your-book");
    } catch {
      return false;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this._onClick);
    document.addEventListener("click", this._onDocumentClick);
    this._openFromLink();
  }
  // Stripped before opening so reload, Back or a reconnect can't reopen it.
  _openFromLink() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("choose-your-book")) return;
    url.searchParams.delete("choose-your-book");
    window.history.replaceState(
      window.history.state,
      "",
      url.pathname + url.search + url.hash
    );
    void this._openWhenRippleReady();
  }
  // Opening before ds-ripple-fill upgrades would skip the fill, so wait (capped).
  async _openWhenRippleReady() {
    await this.updateComplete;
    const deadline = performance.now() + 1500;
    while (this.rippleSelector && !this._ripple() && document.querySelector(this.rippleSelector) && performance.now() < deadline) {
      await new Promise((r6) => requestAnimationFrame(r6));
    }
    if (this.isConnected) this.open("link");
  }
  _releaseScrollLock() {
    document.body.classList.remove("scroll-locked");
  }
};
DsBookFinder.styles = [...BaseComponent.styles, r(ds_book_finder_default)];
__decorateClass([
  n4({ attribute: "trigger-selector" })
], DsBookFinder.prototype, "triggerSelector", 2);
__decorateClass([
  n4({ attribute: "ripple-selector" })
], DsBookFinder.prototype, "rippleSelector", 2);
__decorateClass([
  n4({ type: Number, attribute: "content-delay" })
], DsBookFinder.prototype, "contentDelay", 2);
__decorateClass([
  n4()
], DsBookFinder.prototype, "label", 2);
__decorateClass([
  r5()
], DsBookFinder.prototype, "_open", 2);
DsBookFinder = __decorateClass([
  t3("ds-book-finder")
], DsBookFinder);
export {
  DsBookFinder
};
/*! Bundled license information:

@lit/reactive-element/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/reactive-element.js:
lit-html/lit-html.js:
lit-element/lit-element.js:
@lit/reactive-element/decorators/custom-element.js:
@lit/reactive-element/decorators/property.js:
@lit/reactive-element/decorators/state.js:
@lit/reactive-element/decorators/event-options.js:
@lit/reactive-element/decorators/base.js:
@lit/reactive-element/decorators/query.js:
@lit/reactive-element/decorators/query-all.js:
@lit/reactive-element/decorators/query-async.js:
@lit/reactive-element/decorators/query-assigned-nodes.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
